import SeoHead from '../../components/SeoHead';

export default function AvisoLegalPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Aviso Legal – BN ĀGENZIA"
        description="Aviso legal de BN ĀGENZIA International Placement. Información sobre el titular del sitio web, actividad y condiciones de uso."
        canonical="/aviso-legal"
      />
      {/* Header */}
      <header className="bg-[#1A2B4A] py-6">
        <div className="max-w-4xl mx-auto px-8">
          <a href="/inicio" className="inline-flex items-center text-white hover:text-gray-200 transition-colors cursor-pointer">
            <i className="ri-arrow-left-line mr-2"></i>
            Volver al inicio
          </a>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-8 py-16">
        <h1 className="text-4xl font-bold text-[#1A2B4A] mb-8">Aviso Legal</h1>
        
        <div className="prose prose-lg max-w-none space-y-8">
          <section>
            <p className="text-gray-700 leading-relaxed">
              En cumplimiento de lo dispuesto en la Ley 34/2002, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa de los siguientes datos:
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">Titular del sitio web</h2>
            <ul className="space-y-2 text-gray-700">
              <li><strong>Nombre:</strong> Natalia Araque Do Nascimento</li>
              <li><strong>DNI:</strong> 46276489Y</li>
              <li><strong>Domicilio fiscal:</strong> Puerto de Sagunto, Valencia, España</li>
              <li><strong>Correo electrónico de contacto:</strong> <a href="mailto:info@bnagenzia.com" className="text-[#1A2B4A] hover:underline">info@bnagenzia.com</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">Nombre comercial</h2>
            <p className="text-gray-700">BN ĀGENZIA International Placement</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">Actividad</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              BN ĀGENZIA International Placement es un proyecto profesional orientado a la intermediación laboral internacional y conexión estratégica entre empresas y talento en Europa.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Actualmente, el sitio web tiene carácter informativo y de presentación de servicios. No se realiza actividad comercial directa ni facturación a través del mismo en esta fase.
            </p>
            <p className="text-gray-700 leading-relaxed">
              La titular se reserva el derecho a modificar cualquier tipo de información que pudiera aparecer en el sitio web sin previo aviso.
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#F8F6F3] py-8 mt-16">
        <div className="max-w-4xl mx-auto px-8 text-center">
          <p className="text-sm text-gray-600">© 2025 BN ĀGENZIA. Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>
  );
}